/* Глобальные стили админки.
 *
 * `antd/dist/reset.css` подключён здесь, а не в index.html: antd v6 через
 * CSS-in-JS стилизует только `.ant-*` и до `body` не дотягивается. Без ресета
 * выживает браузерный дефолт `body { margin: 8px }` — белая рамка по всем
 * четырём сторонам вокруг сайдбара, плюс постоянный вертикальный скролл
 * от `Layout { min-height: 100vh }` внутри отступов.
 *
 * Импорт первым: ресет должен оказаться выше рантайм-стилей antd в каскаде. */
@import "antd/dist/reset.css";

/* Браузер должен знать про обе темы: без этого нативные контролы и
 * скроллбары остаются светлыми на тёмной теме. */
:root {
  color-scheme: light dark;
}

/* Ресет задаёт высоту html/body, но не #root — без него `height: 100%`
 * у AntdApp упирается в блок нулевой высоты и ничего не делает. */
#root {
  height: 100%;
}

body {
  overflow-x: hidden;
  /* Ресет antd ставит `html { font-family: sans-serif }`. Токен темы доходит
     только до `.ant-app`, поэтому базовое семейство задаётся здесь — иначе
     всё вне корня приложения рисуется системным гротеском. */
  font-family: "Inter Variable", Inter, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
}

/* Скроллбар в тон теме — иначе на тёмной остаётся светлая полоса. */
* {
  scrollbar-width: thin;
  scrollbar-color: var(--ant-color-border) transparent;
}
